import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import policyHero from '../assets/policy-hero.jpg';

const CookiePolicyPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div>
      <Navbar />
    <div style={{
        backgroundImage: `url(${policyHero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        marginTop: '80px',
        padding: '120px 20px',
        textAlign: 'center',
        color: 'white',
        position: 'relative'
      }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.55)' }}></div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 style={{ fontSize: '48px', fontWeight: '700', marginBottom: '16px' }}>Cookie Policy</h1>
          <p style={{ fontSize: '18px' }}>Learn about how we use cookies and similar technologies to enhance your experience.</p>
          <p style={{ marginTop: '12px' }}>Home &bull; Cookie Policy</p>
        </div>
      </div>

      {/* Cookie Policy Content */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="bg-light rounded p-5">
                <div className="mb-4">
                  <p className="text-muted mb-2">Last updated: {new Date().toLocaleDateString()}</p>
                  <p className="lead">
                    This Cookie Policy explains how Tecnvirons AI Intelligence Solutions uses cookies and similar technologies when you visit our website or use our services.
                  </p>
                </div>

                {/* Section 1 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">1. What Are Cookies?</h3>
                  <p>
                    Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners.
                  </p>
                </div>

                {/* Section 2 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">2. How We Use Cookies</h3>
                  <p className="mb-3">We use cookies for several purposes:</p>
                  <ul>
                    <li><strong>Essential Cookies:</strong> These are necessary for the website to function properly</li>
                    <li><strong>Performance Cookies:</strong> These help us understand how visitors interact with our website</li>
                    <li><strong>Functionality Cookies:</strong> These enable enhanced functionality and personalization</li>
                    <li><strong>Marketing Cookies:</strong> These are used to deliver relevant advertisements</li>
                  </ul>
                </div>

                {/* Section 3 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">3. Types of Cookies We Use</h3>
                  
                  <div className="mb-4">
                    <h5 className="text-secondary mb-2">Essential Cookies</h5>
                    <p>These cookies are strictly necessary for the operation of our website. They enable core functionality such as security, network management, and accessibility.</p>
                  </div>

                  <div className="mb-4">
                    <h5 className="text-secondary mb-2">Analytics Cookies</h5>
                    <p>We use analytics cookies to understand how visitors use our website. This helps us improve our website's performance and user experience.</p>
                  </div>

                  <div className="mb-4">
                    <h5 className="text-secondary mb-2">Functional Cookies</h5>
                    <p>These cookies allow our website to remember choices you make and provide enhanced, more personal features.</p>
                  </div>

                  <div className="mb-4">
                    <h5 className="text-secondary mb-2">Marketing Cookies</h5>
                    <p>These cookies track your online activity to help advertisers deliver more relevant advertising or to limit how many times you see an ad.</p>
                  </div>
                </div>

                {/* Section 4 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">4. Third-Party Cookies</h3>
                  <p className="mb-3">We may also use third-party cookies from trusted partners such as:</p>
                  <ul>
                    <li><strong>Google Analytics:</strong> For website analytics and performance monitoring</li>
                    <li><strong>Social Media Platforms:</strong> For social media integration and sharing</li>
                    <li><strong>Marketing Partners:</strong> For targeted advertising and remarketing</li>
                  </ul>
                </div>

                {/* Section 5 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">5. Managing Your Cookie Preferences</h3>
                  <p className="mb-3">You have several options for managing cookies:</p>
                  
                  <div className="mb-4">
                    <h5 className="text-secondary mb-2">Browser Settings</h5>
                    <p className="mb-2">Most web browsers allow you to control cookies through their settings preferences. You can:</p>
                    <ul>
                      <li>Block all cookies</li>
                      <li>Allow only first-party cookies</li>
                      <li>Delete existing cookies</li>
                      <li>Set up notifications when cookies are sent</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <h5 className="text-secondary mb-2">Opt-Out Tools</h5>
                    <p className="mb-2">You can opt out of certain third-party cookies using industry-provided tools:</p>
                    <ul>
                      <li>Google Analytics Opt-out Browser Add-on</li>
                      <li>Network Advertising Initiative opt-out tool</li>
                      <li>Digital Advertising Alliance opt-out tool</li>
                    </ul>
                  </div>
                </div>

                {/* Section 6 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">6. Cookie Retention</h3>
                  <p className="mb-3">Cookies are retained for different periods depending on their purpose:</p>
                  <ul>
                    <li><strong>Session Cookies:</strong> Deleted when you close your browser</li>
                    <li><strong>Persistent Cookies:</strong> Remain on your device for a set period or until manually deleted</li>
                    <li><strong>Analytics Cookies:</strong> Typically retained for 2 years</li>
                    <li><strong>Marketing Cookies:</strong> Usually retained for 30 days to 2 years</li>
                  </ul>
                </div>

                {/* Section 7 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">7. Impact of Disabling Cookies</h3>
                  <p className="mb-3">If you choose to disable cookies, some features of our website may not function properly. This may include:</p>
                  <ul>
                    <li>Difficulty logging into your account</li>
                    <li>Loss of personalized settings</li>
                    <li>Reduced website functionality</li>
                    <li>Less relevant content and advertisements</li>
                  </ul>
                </div>

                {/* Section 8 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">8. Updates to This Policy</h3>
                  <p>
                    We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Please check this page periodically for updates.
                  </p>
                </div>

                {/* Section 9 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">9. Contact Us</h3>
                  <p className="mb-3">If you have any questions about our use of cookies, please contact us:</p>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Email:</strong> <a href="mailto:privacy@tecnvi-ai.com" className="text-primary">privacy@tecnvi-ai.com</a></p>
                      <p><strong>Phone:</strong> <a href="tel:+918800261119" className="text-primary">+91 88002 61119</a></p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Address:</strong><br />
                        Tecnvirons AI Intelligence Solutions<br />
                        India
                      </p>
                    </div>
                  </div>
                </div>

                {/* Back to Top */}
                <div className="text-center">
                  <a href="#top" className="btn btn-primary py-2 px-4">
                    <i className="fa fa-arrow-up me-2"></i>Back to Top
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<Footer />
    </div>
  );
};

export default CookiePolicyPage;
